export default __webpack_public_path__ + "static/banner-image-20ad2fb1dc7525f750b06f9998be1afb.png";